export const BODYTEXT = 'bodytext'
export const EMPTY_STRING = ''
export const ORIGIN_LOCATION = 'originLocation'
